import React, { memo, useEffect, useCallback, useState} from 'react';
import {hashCode} from 'utils/hashCode.js';
import TrackLengthBar from '../track/TrackLengthBar.js';
import { createSelector } from 'reselect'
import {connect} from 'react-redux';
import StepsRowBottom from '../StepsRowBottom.js';
import StepComponent from '../track/StepComponent.js';
import StepData from 'pattern/StepData.js';

const DEFAULT_STEP_DATA = new StepData();

const StepsRow = memo(({
    stepGroups,
    cursorStep,
    chunk,
    show,
    stepsLength,
    stepNumbers,
    track,
    resolution,
    barLength,
    sequencerEngine,
    id,
    selectedSteps,
    stepsSelection,
    trackLengthMode,
    showPianoRoll,
    isSelectedTrack,
    isMini,
    trackColor,
    chunkSize,
    stepsInRow,
    partNumber=0,
    rowHash
}) => { 
    let className = 'steps-row';
    let odd = false;
    if (Math.floor(chunk / 2) % 2 === 1) {
        className += ' odd';
        odd = true;
    }
    let isAlternateColor = (i) => Math.ceil((i + 1) / barLength) % 2 != 0;
    var slices = track.numberOfSlices();

    let cursor = sequencerEngine.cursor;
    let selectedStepNumber= sequencerEngine.getSelectedStep() 
    let stepDatas = sequencerEngine.state.tracks.trackStepIds[track.id] || {};
    let steps = sequencerEngine.state.tracks.trackSteps[track.id];
    let fills = sequencerEngine.state.tracks.trackFills[track.id];

    return (
        <div className="steps-row-container">
          <div className={className}>
            {stepNumbers.map(
                (stepNumber,i) => 
                    <StepComponent
                      id={id}
                      odd={odd}
                      key={i}
                      isCursor={cursorStep === stepNumber}
                      on={steps && steps[stepNumber]}
                      fill={fills && fills[stepNumber]}
                      showParameters={!isMini && cursor.track === track.trackNumber && cursor.show && selectedStepNumber === stepNumber}
                      showPianoRoll={showPianoRoll}
                      selectedSteps={selectedSteps}
                      stepsSelection={stepsSelection}
                      group={stepDatas[stepNumber] ? stepDatas[stepNumber].group : undefined}
                      slice={stepDatas[stepNumber] ? stepDatas[stepNumber].slice : 0}
                      velocity={stepDatas[stepNumber] ? stepDatas[stepNumber].velocity : 1}
                      trackColor={trackColor}
                      sequencerEngine={sequencerEngine}
                      resolution={resolution}
                      trackNumber={track.trackNumber}
                      stepGroups={stepGroups}
                      resolution={resolution}
                      stepNumber={stepNumber}
                      trackData={track}
                      isAlternateColor={isAlternateColor(i, barLength, resolution)}
                      slices={slices}
                      track={track}
                    />)}
 
          </div>
          {!isMini && trackLengthMode && isSelectedTrack ?
           <TrackLengthBar
             resizable={chunk === chunkSize - 1}
             rowLength={steps.length}
             track={track}
             color={trackColor}
             row={chunk}/> : ''}
          <StepsRowBottom
                        isMini={isMini}
                        sequencerEngine={sequencerEngine}
                        track={track}
                        stepsInRow={stepsInRow}
                        chunk={chunk + partNumber*4}/>
        </div>
    );
});

const getStepDatas = (state, props) => state.tracks.trackSteps[props.track.id];
const getGroups = (state, props) => state.tracks.trackStepGroups[props.track.id];
const getFrom = (state, props) => props.chunk*props.stepsInRow;
const getTo = (state, props) => (props.chunk + 1) * props.stepsInRow;
const getRowHash = createSelector(
    [getStepDatas, getFrom, getTo],
    (stepDatas, from, to, groups) => hashCode([... (stepDatas || []), ... (groups || [])].slice(from, to).join(',')));

const mapStateToProps = (state, props) => {
    let selection = state.steps.stepsSelection;
    let cursorStep = -1;
    if (state.mix.selectedTrack === props.track.trackNumber) {
        let _cursorStep = state.mix.selectedStep;
        // is the cursor in this row?
        let chunk = props.chunk + props.partNumber * 4;
        if (_cursorStep >= chunk * props.stepsInRow && _cursorStep <= (chunk + 1) * props.stepsInRow) {
            cursorStep = _cursorStep;
        }
    }
    let selectedSteps = state.keyboard.selectedPianoRollSteps;
    if (selectedSteps && selectedSteps[0] &&
        selectedSteps[0].track !== props.track) {
        selectedSteps = undefined;
    }
    return {
        fills: state.tracks.trackFills[props.track.id],
        rowHash: getRowHash(state, props),
        selectedSteps,
        stepsSelection: selection !== undefined && selection.trackNumber === props.track.trackNumber ?
            selection : undefined,
        cursorStep: cursorStep,
        cursorShow: props.sequencerEngine.cursor.show,
        showPianoRoll: state.sequencer.showPianoRoll,
        stepGroups: state.steps.stepGroups
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepsRow);
